import { render } from "./DefaultObjSelector.vue?vue&type=template&id=808b1e3c"
import script from "./DefaultObjSelector.vue?vue&type=script&lang=js"
export * from "./DefaultObjSelector.vue?vue&type=script&lang=js"

import "./DefaultObjSelector.vue?vue&type=style&index=0&id=808b1e3c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__